/**
 * Тул для вывода ошибок.
 * @private
 */
class Error  {

  constructor (name: string, message: string) {
    let errorObject = new Error(message, name);

    errorObject['name'] = name || 'Ошибка';

    this['name'] = errorObject['name'];
    this['message'] = errorObject['message'];

    if (errorObject['stack']) {
      this['stack'] = errorObject['stack'];
    }

    //Вывод в консоль
    this.toString = () => {
      return `${this['name']}: ${this['message']}`;
    };

    return this;
  }
};

export default Error;
